<template>
  <footer class="border-t border-white/10 bg-slate-950">
    <div class="mx-auto grid max-w-7xl gap-8 px-6 py-10 md:grid-cols-[1.6fr_1fr_1fr]">
      <div>
        <div class="font-display text-lg font-bold text-white">{{ i18n.t('common.brand') }}</div>
        <p class="mt-3 max-w-xl text-sm leading-6 text-slate-400">
          {{ i18n.t('common.localModeNotice') }}
        </p>
        <a
          :href="contactInfo.telegramUrl"
          target="_blank"
          rel="noreferrer"
          class="cta-secondary mt-5 inline-flex"
        >
          {{ i18n.t('common.telegram') }} · {{ contactInfo.telegramHandle }}
        </a>
      </div>

      <div>
        <div class="text-sm font-semibold uppercase tracking-[0.18em] text-slate-500">{{ i18n.t('common.footerProduct') }}</div>
        <div class="mt-4 flex flex-col gap-3 text-sm text-slate-300">
          <router-link to="/" class="transition hover:text-white">{{ i18n.t('nav.home') }}</router-link>
          <router-link to="/pricing" class="transition hover:text-white">{{ i18n.t('nav.pricing') }}</router-link>
          <router-link to="/docs" class="transition hover:text-white">{{ i18n.t('nav.docs') }}</router-link>
          <router-link to="/geo" class="transition hover:text-white">{{ i18n.t('nav.geo') }}</router-link>
        </div>
      </div>

      <div>
        <div class="text-sm font-semibold uppercase tracking-[0.18em] text-slate-500">{{ i18n.t('common.footerWorkspace') }}</div>
        <div class="mt-4 flex flex-col gap-3 text-sm text-slate-300">
          <router-link to="/member" class="transition hover:text-white">{{ i18n.t('nav.member') }}</router-link>
          <router-link to="/console" class="transition hover:text-white">{{ i18n.t('nav.console') }}</router-link>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup>
import { useI18nStore } from '../../stores/i18n';
import { contactInfo } from '../../content/contact';

const i18n = useI18nStore();
</script>
